"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.throttle = exports.debounce = exports.memo = exports.proxied = exports.partob = exports.partial = exports.compose = exports.chain = void 0;
var chain = function () {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return funcs.slice(1).reduce(function (acc, fn) { return fn(acc); }, funcs[0].apply(funcs, args));
    };
};
exports.chain = chain;
var compose = function () {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    return funcs.reverse().reduce(function (acc, fn) { return fn(acc); });
};
exports.compose = compose;
var partial = function (fn) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return function () {
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        return fn.apply(void 0, __spreadArray(__spreadArray([], args, false), rest, false));
    };
};
exports.partial = partial;
/**
 * Like partial but for unary functions that accept
 * a single object argument
 */
var partob = function (fn, argobj) {
    return function (restobj) {
        return fn(__assign(__assign({}, argobj), restobj));
    };
};
exports.partob = partob;
/**
 * Creates a Proxy object that will dynamically
 * call the handler argument when attributes are
 * accessed
 */
var proxied = function (handler) {
    return new Proxy({}, {
        get: function (target, propertyName) { return handler(propertyName); }
    });
};
exports.proxied = proxied;
var memoize = function (cache, func, keyFunc, ttl) {
    return function callWithMemo() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = keyFunc ? keyFunc.apply(void 0, args) : JSON.stringify({ args: args });
        var existing = cache[key];
        if (existing !== undefined) {
            if (existing.exp > new Date().getTime()) {
                return existing.value;
            }
        }
        var result = func.apply(void 0, args);
        cache[key] = {
            exp: new Date().getTime() + ttl,
            value: result
        };
        return result;
    };
};
/**
 * Creates a memoized function using the key and ttl
 * options. The returned function will only execute
 * the source function when no value has previously
 * been computed or the previous value has expired
 */
var memo = function (func, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.key, key = _c === void 0 ? null : _c, _d = _b.ttl, ttl = _d === void 0 ? 300 : _d;
    return memoize({}, func, key, ttl);
};
exports.memo = memo;
/**
 * Given a delay and a function returns a new function
 * that will only call the source function after delay
 * milliseconds have passed without any invocations
 */
var debounce = function (_a, func) {
    var delay = _a.delay;
    var timer = null;
    var debounced = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = setTimeout(function () { return func.apply(void 0, args); }, delay);
    };
    return debounced;
};
exports.debounce = debounce;
/**
 * Given an interval and a function returns a new function
 * that will only call the source function if interval milliseconds
 * have passed since the last invocation
 */
var throttle = function (_a, func) {
    var interval = _a.interval;
    var ready = true;
    var throttled = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!ready)
            return;
        func.apply(void 0, args);
        ready = false;
        setTimeout(function () {
            ready = true;
        }, interval);
    };
    return throttled;
};
exports.throttle = throttle;
//# sourceMappingURL=curry.js.map